import { render } from "./post.vue?vue&type=template&id=3afa90e6&scoped=true"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"

import "./post.vue?vue&type=style&index=0&id=3afa90e6&scoped=true&lang=css"
import "./post.vue?vue&type=style&index=1&id=3afa90e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afa90e6"]])

export default __exports__